import hospitalClinics from "./hospitalclinics"


const whichHospital=(clinic, pathwayType)=>{
    let hospitals=[]
    for (let hospital in hospitalClinics)
        {
        if (hospitalClinics[hospital][pathwayType].includes(clinic))
        hospitals.push(hospital)
        }

    let hopitalQuestion={
        label:"Which hospital trust do you want to refer to?",
        controlType:"radio button",
        options:[...hospitals],
        required:true
    }

return (hopitalQuestion)
}
export default whichHospital